
import { Main } from './Main';


const routes = [
    { path: "/", component: Main},
]

export default routes;